import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// SECTION: PAYMENT THUNKS

export const getUnitPaymentDetails = createAsyncThunk(
    "payment/unitPaymentDetails",
    async (unitId, { rejectWithValue }) => {
      try {
        const { data } = await api.get(`payment/unit-tenant/view-payments/${unitId}`);
        return data; // expects { data: { tenantInfoCards: {...}, payments: [...] } }
      } catch (err) {
        const message =
          err?.response?.data?.message || err.message || "Failed to fetch unit payment details";
        return rejectWithValue(message);
      }
    }
  );

// get tenant payment details
export const getTenantPaymentDetails = createAsyncThunk(
    "payment/getTenantPaymentDetails", async (data) => {
        const response = await api.post("payment/getTenantPaymentDetails", data)
        return response.data;
    }
);

// get checkout session
export const getCheckoutSession = createAsyncThunk(
    "payment/getCheckoutSession", async (data) => {
        const response = await api.post("payment/create-checkout-session", data)
        return response.data;
    }
);

// get payment confirmation
export const getPaymentConfirmation = createAsyncThunk(
    "payment/getPaymentConfirmation", async (transactionId) => {
        const response = await api.post(`payment/getPaymetSuccessDetails/${transactionId}`);
        return response.data;
    }
);

export const valildatePayoutMobileNumber = createAsyncThunk(
    "payment/validatePayoutMobileNumber", async (data) => {
        const response = await api.post("payment/validate/mobile-number", data);
        return response.data;
    }
);